module.exports = __webpack_public_path__ + "img/制何首乌.23520fb9.jpg";